<template>
  <div class="row">
    <div class="col">
      <Button @click="redirectionAjouterIntervention"> Ajouter</Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer</Button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['rechercher'],
  methods: {
    redirectionAjouterIntervention() {
      this.$router.push({name: 'ajouterIntervention'});
    },
    rechercher() {
      this.$emit('rechercher');
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
